import { useRef } from "react";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { loadGPXFromFileInputEvent } from "PosterEditor/utils/file-import";
import { CTAButton } from "BEDROCK/shared-components/cta-button";

interface UploadButtonProps {
  title?: string;
  children?: React.ReactNode;
}

export const GPXUploadButton = (props: UploadButtonProps) => {
  const { setCoordinates } = usePosterProject();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const data = await loadGPXFromFileInputEvent(event);
    let name = data?.name ?? event.target.files?.[0].name ?? "No file name";
    if (data?.coordinates) {
      setCoordinates(data.coordinates, name, data.data);
    }
  };

  if (props.children) {
    return (
      <>
        <button
          onClick={handleClick}
          style={{ all: "unset", cursor: "pointer" }}
        >
          {props.children}
        </button>
        <input
          ref={inputRef}
          type="file"
          accept=".gpx"
          style={{ display: "none" }}
          onChange={handleFileUpload}
        />
      </>
    );
  }

  return (
    <>
      <CTAButton variant="PRIMARY" onClick={handleClick}>
        {props.title ?? "Upload a file"}
      </CTAButton>

      <input
        ref={inputRef}
        type="file"
        accept=".gpx"
        style={{ display: "none" }}
        onChange={handleFileUpload}
      />
    </>
  );
};
